import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUi from 'element-ui'
import 'element-ui/lib/index.js'
import 'babel-polyfill'
import { HappyScroll } from 'vue-happy-scroll'
import 'vue-happy-scroll/docs/happy-scroll.css'

import './assets/iconfont/iconfont.css'
import 'font-awesome.css'

import ajax from './api/ajax/ajax'
Vue.prototype.$nyAjax = ajax
Vue.component('happy-scroll', HappyScroll)
Vue.use(ElementUi)

Vue.config.productionTip = false
// 阿里OSS文件上传
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js